import { z } from "zod";

export const supplierReportsFiltersSchema = z.object({
  insurance_company_id: z
    .string()
    .min(1, "reports.supplierTab.supplierRequired"),
  product_id: z.string().optional(),
  status: z.string().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
});

export type TSupplierReportsFiltersFormData = z.infer<
  typeof supplierReportsFiltersSchema
>;
